import { api } from '@services';
import { FieldTypeOptions } from '@models/CustomField.model';

interface IPatchField {
  name: string;
  type: FieldTypeOptions;
  isUnique?: boolean;
  defaultValue?: string;
  description?: string;
  showOnOnboard?: boolean;
  isSearchable?: boolean;
  content?: string;
  equipmentId?: string;
  selectValues?: string[];
}
interface IPatchRequest {
  studioId: string;
  data: IPatchField;
}
const createCustomField = async ({
  data,
  studioId,
}: IPatchRequest): Promise<void> => {
  await api.post(`/customFields/adm/${studioId}`, data);
};

export { createCustomField };
